import { SVGAttributes } from 'react';
import styled from 'styled-components';

import { responsive, sp } from '@main/theme';

/**
 * Props
 */
export interface DsrIconProps extends SVGAttributes<SVGSVGElement> {
  /** Primary color (used on the accent parts of the icon) */
  primaryColor: string;
  /** Selected color (used when the icon is selected) */
  selectedColor: string;
  /** Should the icon show a selected state? */
  selected?: boolean;
}

/**
 * Svg
 */
export const Svg = styled.svg`
  align-self: center;
  flex-shrink: 0; // Make sure that this doesn't get squished by the text

  ${responsive.beforeTablet} {
    width: ${sp(5)};
    height: ${sp(5)};
    margin-right: ${sp(1)};
  }

  ${responsive.atLeastTablet} {
    width: ${sp(6.5)};
    height: ${sp(6.5)};
    margin-right: ${sp(2)};
  }
`;
